import React, { Component } from 'react';
import { scrollSpy } from 'react-scroll';
import NavLink from './NavLink';

import './Navigation.css';

export default class Navigation extends Component {
  componentDidMount() {
    scrollSpy.update();
  }

  render() {
    return (
      <nav>
        <NavLink to="work" title="Featured Work" />
        <NavLink to="skills" title="Skills" />
        <NavLink to="about" title="About" />
        <NavLink to="contact" title="Contact" />
      </nav>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Navigation.js